/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Tournament_Decklist_Api_TitleInputs */



/**
* | output |
* | --- |
* | "Tournament Decklist API" |
*
* @param {Help_Article_Tournament_Decklist_Api_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_tournament_decklist_api_title = /** @type {((inputs?: Help_Article_Tournament_Decklist_Api_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Tournament_Decklist_Api_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Turnier-Deckliste-API")
	if (locale === "fr") return /** @type {LocalizedString} */ ("API de decklists de tournoi")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("赛事卡组表 API")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("賽事牌組清單 API")
	if (locale === "ko") return /** @type {LocalizedString} */ ("Tournament Decklist API")
	return /** @type {LocalizedString} */ ("Tournament Decklist API")
});